"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshLinkTracking = void 0;
const browser_plugin_link_click_tracking_1 = require("@snowplow/browser-plugin-link-click-tracking");
const browser_tracker_1 = require("@snowplow/browser-tracker");
const cross_domain_linker_criterion_1 = require("./cross-domain-linker-criterion");
/**
 * Refresh link tracking, including cross-domain tracking, for links that were
 * added after the page has loaded.
 *
 * v.0.12.0;
 * @public
 *
 * @param config - Configuration which includes:
 * - crossDomainLinkerCriterion: Optional function that receives an
 *   HTMLAnchorElement or HTMLAreaElement that's been clicked and returns
 *   true/false depending on whether the navigation performed by that click
 *   should include the Snowplow cross-domain tracking parameters.
 *
 * @example
 * ```ts
 * import { refreshLinkTracking } from '@hc-frontend/third-party-snowplow';
 *
 * refreshLinkTracking({});
 * ```
 */
function refreshLinkTracking({ crossDomainLinkerCriterion = cross_domain_linker_criterion_1.linksToHcDomainCriterion, }) {
    (0, browser_plugin_link_click_tracking_1.refreshLinkClickTracking)();
    (0, browser_tracker_1.crossDomainLinker)(crossDomainLinkerCriterion);
}
exports.refreshLinkTracking = refreshLinkTracking;
//# sourceMappingURL=refresh-link-tracking.js.map